export const SERVER_TIMEOUT = 60000;

export const MOCK_ORDER_EXECUTION_TIMEOUT = 1000;

export const UNSET_NEW_NOTIFICATION_DELAY = 5000;

export const READ_DELAY = 2000;

export const RESOLVE_DELAY = 100;

//notificaion intersection
//to handle read
export const READ_INTERSECT_RATIO = 0.9;

export const BLOTTER_CHUNK_SIZE = 50;

/**
 * Throtle notifications to resolve by bunch
 */
export const THROTLE_NOTIFICATIONS_RESOLVE = 500;
